import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Grid, Button, Container, Stack, Typography } from '@mui/material';
// components
import { useDispatch, useSelector } from 'react-redux';
import Blogmodel from '../components/models/blog/Blogmodel';
import { validateBlog } from '../validation/Blog';
import { addBlog, getBlog } from '../redux/actions/Blogaction';
import Iconify from '../components/iconify';
import { BlogPostCard } from '../sections/@dashboard/blog';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

// ----------------------------------------------------------------------

export default function BlogPage() {
  const [open, setOpen] = useState(null);
  const [fields, setFields] = useState();
  const [fielderror, setFieldError] = useState({});
  const [issubmit, setIssubmit] = useState(false);

  const dispatch = useDispatch();

  // add blog model
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getBlogs = useSelector((state) => {
    return state?.Blog?.getBlog?.data;
  });

  useEffect(() => {
    dispatch(getBlog());
  }, []);

  // handelfield change

  const handleChange = (e) => {
    const keyName = e.target.name;
    const keyValue = e.target.value;
    setFields((prevState) => ({
      ...prevState,
      [keyName]: keyValue,
    }));
    if (issubmit) {
      setFieldError(validateBlog({ ...fields, keyName: fields }));
    }
  };

  // handelsubmit button
  const handleClick = () => {
    const obj = {
      title: fields?.title,
      url: fields?.url,
    };

    setIssubmit(true);
    const error = validateBlog(fields);
    if (Object.keys(error).length === 0) {
      dispatch(addBlog(obj));
      setOpen(false);
    } else {
      console.log('Error:', error);
    }
    setFieldError(validateBlog(fields));

    // setOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Dashboard: Blog | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Blog
          </Typography>
          <Button onClick={handleOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New Blog
          </Button>

          <Blogmodel
            open={open}
            handleClose={handleClose}
            handleChange={handleChange}
            fielderror={fielderror}
            handleClick={handleClick}
          />
        </Stack>

        {/* <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between">
          <BlogPostsSearch posts={getBlogs} />
          <BlogPostsSort options={SORT_OPTIONS} />
        </Stack> */}

        <Grid container spacing={3}>
          {getBlogs?.map((post, index) => (
            <BlogPostCard
              title={post?.title}
              // key={post?.id}
              post={post}
              index={index}
            />
          ))}
        </Grid>
      </Container>
    </>
  );
}
